import React from "react";
import { useContext } from "react";
import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Slider, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({}));

const CustomSlider = (props) => {
  const classes = useStyles();
  const { language } = useContext(LanguageContext);
  const options = localize(props.options, language) || [];

  return (
    <>
      <Typography style={{ marginTop: "10px", paddingLeft: 70 }}>
        {localize(props.name, language)}
      </Typography>
      <br />
      <Grid container>
        <Grid item xs={3}></Grid>
        <Grid item xs={6}>
          <Slider
            defaultValue={5}
            valueLabelDisplay="auto"
            step={1}
            marks={[
              { value: 0, label: localize("levels.low", language) },
              { value: 5, label: localize("levels.medium", language) },
              { value: 10, label: localize("levels.high", language) },
            ]}
            min={0}
            max={10}
          />
        </Grid>
        <Grid item xs={3}></Grid>
      </Grid>
    </>
  );
};

export default CustomSlider;
